import { render, staticRenderFns } from "./DetailsPage.vue?vue&type=template&id=976e58e8&scoped=true&"
import script from "./DetailsPage.vue?vue&type=script&lang=js&"
export * from "./DetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976e58e8",
  null
  
)

export default component.exports